import React, { Component } from 'react';
import { useCamera } from './captureCamera';
// import { useWindowSize } from '@tofusoup429/use-window-size';
import LensSharpIcon from '@material-ui/icons/LensSharp';
import Button from '@material-ui/core/Button';

class FullScreenMobileView extends Component {
    // let {width, height} = useWindowSize() // get window width and height as everytime screen resized. 
    state = {
        width: 600,
        height: 800,
        imageDatas: []
    }

    componentDidMount = () => {
        const { captureImage, imageData } = useCamera();
        this.setState({
            captureImage,
            imageData,
            imageDatas: {
                ...this.state.imageDatas,
                imageData
            }
        })
        //whenever imageData changed, which means captureImage is executed, imageUrl is cumulated in the array. 

    }

    takePicture = async() => {
        const capturedPic = await this.state.captureImage()
        var arr = capturedPic.split(','), mime = arr[0].match(/:(.*?);/)[1],
            bstr = atob(arr[1]), n = bstr.length, u8arr = new Uint8Array(n);
        while(n--){
            u8arr[n] = bstr.charCodeAt(n);
        }
        const blobPic = new Blob([u8arr], {type:mime});
        let video = document.getElementsByTagName('video')[0];
        video.pause();
        video.srcObject.getVideoTracks()[0].stop()
        this.props.cameraPic(blobPic)
    }

    render() {
        return (
            <div className='cameraModal'>
                <div className='cameraInnerDiv' style={{ width: this.state.width, paddingTop: '30vh' }}>
                    <div style={{ display: "flex", flexDirection: "column", justifyContent: "start", alignItems: "flex-start" }}>
                        <div className="VideoAndCanvas">
                            <video width={this.state.width} style={{ objectFit: 'contain' }} />
                            <canvas style={{ opacity: 0 }} />
                        </div>
                        <div className='cameraCaptureButtons' style={{width: this.state.width*.5}}>
                            <Button variant="contained" color="primary" className="ButtonShadow" onClick={() => this.takePicture()}>Capture</Button>
                            <Button variant="contained" color="secondary" className="ButtonShadow" onClick={() => this.props.cancelPic()} >Cancel</Button>
                        </div>
                        {/* <LensSharpIcon id='CaptureImageButton' fontSize='large' color="secondary" style={{ width: '75px', height: "75px", position: 'absolute', top: this.state.height, left: this.state.width, transform: "translate(-50%, -50%)" }} onClick={() => this.state.captureImage()} /> */}
                        {this.state.imageDatas.length > 0 &&
                            <div id="Images" style={{ display: "flex", flexDirection: "row", justifyContent: "center", flexWrap: 'wrap', margin: '1%', padding: '1%' }}>
                                {
                                    this.state.imageDatas.map((imageData, index) => {
                                        return (
                                            imageData.length > 10 && <img key={index} src={imageData} width={this.state.width * 0.45} alt='NoImage' />
                                        )
                                    })
                                }
                            </div>
                        }
                    </div>
                </div>
            </div>
        )
    }
}

export default FullScreenMobileView;


// WEBPACK FOOTER //
// ./src/components/FullScreenMobileView.js